import { Selector } from '@ngxs/store';
import { AccessorySearchState, AccessorySearchStateModel } from './accessory-search.state';
import { Injectable } from '@angular/core';
import { AccessoryItem } from '@sales/models/accessory.model';
import { AccessoryFiltersResponse } from '../models/accessory-filters.model';

@Injectable()
export class AccessorySearchSelectors {
  @Selector([AccessorySearchState])
  static allSearchResults(state: AccessorySearchStateModel): AccessoryItem[] {
    return state.searchResults;
  }

  @Selector([AccessorySearchState])
  static allFilters(state: AccessorySearchStateModel): AccessoryFiltersResponse {
    return state.accessoryFilters;
  }

  @Selector([AccessorySearchState])
  static isLoadingAccessorySearchResults(state: AccessorySearchStateModel): boolean {
    return state.isLoadingAccessorySearchResults;
  }

  @Selector([AccessorySearchState])
  static isLoadingFilters(state: AccessorySearchStateModel): boolean {
    return state.isLoadingAccessoryFilters;
  }

  @Selector([AccessorySearchSelectors.allSearchResults])
  static selectProductSearchManufacturers(allResults: AccessoryItem[]): string[] {
    return [...new Set(allResults.map(result => result.manufacturer))];
  }
}
